/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { _TYPES_ } from "../utils/types";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _PAGE_SIZE_ } from "../../../middlewares/other/tools";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { pushOneArt } from "../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  Modal,
  GoBack,
  MySearch,
  MyButton,
  Pagination,
  DashboardIntro,
} from "../../home/component/Component";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import PromoteContent from "../utils/PromoteContent";
import { FaRegCheckSquare, FaRegSquare, FaRegTrashAlt } from "react-icons/fa";
import { RiRefreshLine } from "react-icons/ri";

const addRoute = "/data/art/add";
const editRoute = "/data/art/edit";
const doseeDataRoutes = "/dosee/data";

const Overview = () => {
  const [artsList, setArtsList] = useState([]);
  const { arts, artsCount, fetchDoSeeData, deleteOneContent } =
    useDoSeeDataContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);
  const [localSearch, setLocalSearch] = useState([]);

  const [loading, setLoading] = useState(false);

  const [selectedContentIds, setSelectedContentIds] = useState([]);

  const {
    country_id,
    entry_label,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const data_request_body = {
    country_id,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    content: _TYPES_?.ART,
  };

  useEffect(() => {
    if (!arts) fetchDoSeeData(data_request_body, page, pageSize);
    setArtsList(arts);
  }, [arts]);

  const reloadData = () => fetchDoSeeData(data_request_body, page, pageSize);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    arts.map((_art_) => {
      if (_art_.title.toString().toLowerCase().includes(key))
        return searchArray.push(_art_);
      return true;
    });

    setArtsList(searchArray);
    if (key === "") setArtsList(arts);
  };

  const LocalData = localSearch?.length > 0 ? localSearch : artsList;

  const deleteMany = async () => {
    setLoading(true);

    for (let i = 0; i < selectedContentIds.length; i++) {
      await deleteOneContent({
        data_id: selectedContentIds[i],
        content: _TYPES_.ART,
      });
    }

    setLoading(false);

    reloadData();
  };

  return (
    <div className="p-3 lg:p-4  h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <BreadCrumbComponent />
      <GoBack props={{ route: doseeDataRoutes }} />
      <div className="my-3">
        <DashboardIntro props={{ intro: `Arts`, name: entry_label }} />
      </div>

      <div className="flex flex-col justify-center">
        <MySearch
          type={_TYPES_.ART}
          value={localSearch}
          showGlobalSearch={true}
          setValue={setLocalSearch}
          onChange={(e) => SearchList(e)}
        />

        <div className="w-full flex justify-end my-5">
          {country_id ? (
            <Link to={addRoute}>
              <MyButton
                title="Add Art"
                className="py-3 px-8 bg-blue-900 hover:bg-blue-600"
                onClick={() => {}}
              />
            </Link>
          ) : null}
        </div>

        <div className="flex items-center">
          <MyButton className="text-black flex items-center space-x-2">
            {selectedContentIds?.length === LocalData?.length ? (
              <FaRegCheckSquare
                onClick={() => setSelectedContentIds([])}
                className="text-green-500 cursor-pointer text-lg"
              />
            ) : (
              <FaRegSquare
                onClick={() => {
                  const ids = LocalData.map((art) => art?.art_id);
                  setSelectedContentIds(ids);
                }}
                className="cursor-pointer text-black text-lg"
              />
            )}
            <p className="text-black">
              {selectedContentIds.length === LocalData?.length
                ? "Unselect All"
                : "Select All"}
            </p>
          </MyButton>

          <MyButton
            onClick={deleteMany}
            className="text-black flex items-center space-x-2"
          >
            {loading ? (
              <RiRefreshLine className="text-black text-lg animate-spin" />
            ) : (
              <FaRegTrashAlt className="text-red-500 cursor-pointer text-base" />
            )}
            <p className="text-black">
              Delete {selectedContentIds?.length} Item(s)
            </p>
          </MyButton>
        </div>

        <div className="mb-5 overflow-y-auto w-full py-2">
          <table className="table-auto w-full border-collapse border border-gray-300 text-xs text-left">
            <thead>
              <tr className="space-x-2">
                <th className="border p-2 lg:px-4 font-bold w-1/3">Select</th>
                <th className="border p-2 lg:px-4 font-bold w-1/3">Title</th>
                <th className="border p-2 lg:px-4 font-bold w-1/3">Slug</th>
                <th className="border text-center w-1/3">Action</th>
              </tr>
            </thead>
            <tbody className="space-x-2 text-left border-gray-300">
              {arts || LocalData ? (
                LocalData?.map((art, key) => (
                  <tr key={key}>
                    <td className="border px-2 lg:px-4 w-1/3 text-lg">
                      {selectedContentIds.includes(art?.art_id) ? (
                        <MyButton
                          onClick={() => {
                            const filteredIds = selectedContentIds.filter(
                              (id) => id !== art?.art_id
                            );
                            setSelectedContentIds(filteredIds);
                          }}
                        >
                          <FaRegCheckSquare className="text-green-500 cursor-pointer text-lg" />
                        </MyButton>
                      ) : (
                        <MyButton
                          onClick={() =>
                            setSelectedContentIds([
                              ...selectedContentIds,
                              art?.art_id,
                            ])
                          }
                        >
                          <FaRegSquare className="cursor-pointer text-black text-lg" />
                        </MyButton>
                      )}
                    </td>
                    <td className="border px-2 lg:px-4 w-1/3">{art.title}</td>
                    <td className="border px-2 lg:px-4 w-1/3">{art.slug}</td>
                    <td className="border w-1/3">
                      <ActionButton props={art} reloadData={reloadData} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="border px-2 lg:px-4 w-1/3">-</td>
                  <td className="border px-2 lg:px-4 w-1/3">-</td>
                  <td className="border px-2 lg:px-4 w-1/3">-</td>
                  <td className="border px-2 lg:px-4 w-1/3">-</td>
                  <td className="border">-</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total_items={artsCount}
          callbackFunction={(p, size) => {
            fetchDoSeeData(data_request_body, p, size);
          }}
        />
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props, reloadData }) => {
  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);
  const { arts, deleteOneContent, updateOneContent } = useDoSeeDataContext();

  const [showModal, setShowModal] = useState(false);

  const [promote, setPromote] = useState(false);
  const [promoteLoader, setPromoteLoader] = useState(false);

  const art_id = props?.art_id;
  const art_title = props?.title;
  const art = props;

  const deleteOneArtById = async (art_id) => {
    const { status } = await deleteOneContent({
      data_id: art_id,
      content: _TYPES_.ART,
    });
    setShowModal(false);
    if (status === 200) {
      reloadData();
    }
  };

  const buildData = (object, position) => {
    return {
      country_id: object?.country_id,
      description: object?.description,
      first_level_id: object?.first_level_id,
      fourth_level_id: object?.fourth_level_id,
      promoted: `${position}`,
      second_level_id: object?.second_level_id,
      slug: object?.slug,
      third_level_id: object?.third_level_id,
      thumbnail: object?.thumbnail,
      title: object?.title,
      status: object?.status,
    };
  };

  /**
   *
   * @author Ntavigwa Bashombe
   * @param {*} art
   */
  const promotion = async (position) => {
    const previousPromoted = arts?.find(
      (art) => art?.promoted === String(position)
    );

    setPromoteLoader(true);

    const { status } = await updateOneContent({
      data_id: art?.art_id,
      data: buildData(props, position),
      content: _TYPES_.ART,
    });

    if (previousPromoted) {
      await updateOneContent({
        data_id: previousPromoted?.art_id,
        data: buildData(previousPromoted, "no"),
        content: _TYPES_.ART,
      });
    }

    setPromoteLoader(false);
    setPromote(false);

    if (status === 200) {
      reloadData();
    }
  };

  const suspension = async (art) => {
    const data = {
      country_id: art?.country_id,
      description: art?.description,
      first_level_id: art?.first_level_id,
      fourth_level_id: art?.fourth_level_id,
      second_level_id: art?.second_level_id,
      status: art?.status === 1 ? 0 : 1,
      third_level_id: art?.third_level_id,
      thumbnail: art?.thumbnail,
      title: art?.title,
      slug: art?.slug,
    };

    const { status } = await updateOneContent({
      data_id: art?.art_id,
      data: data,
      content: _TYPES_.ART,
    });

    if (status === 200) {
      reloadData();
    }
  };

  return (
    <>
      <Modal
        props={{
          name: art_title,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneArtById(art_id),
        }}
      />

      <PromoteContent
        visible={promote}
        setVisible={setPromote}
        loading={promoteLoader}
        ids={arts
          ?.filter(
            (art) => !["yes", "no", null, undefined].includes(art?.promoted)
          )
          .map((art) => ({
            id: art?.art_id,
            title: art?.title,
            position: parseInt(art?.promoted),
          }))}
        onClick={(position) => promotion(position)}
      />

      <div className="flex flex-row justify-end items-center px-2 py-3 space-x-4 text-xs">
        {isSuperAdmin ? (
          <>
            <MyButton
              title={art?.status === 1 ? "Suspend" : "Unsuspend"}
              className={`py-3 px-8 ${
                art?.status === 1
                  ? "bg-gray-900 hover:bg-gray-600"
                  : "bg-green-500 hover:bg-green-400"
              }`}
              onClick={() => suspension(art)}
            />
            <MyButton
              title={
                ["yes", "no", null, undefined].includes(art.promoted)
                  ? "Promote"
                  : "Unpromote"
              }
              className={`py-3 px-8 ${
                ["yes", "no", null, undefined].includes(art.promoted)
                  ? "bg-gray-900 hover:bg-gray-600"
                  : "bg-green-500 hover:bg-green-400"
              }`}
              onClick={() => setPromote(true)}
            />
          </>
        ) : null}

        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className={`py-3 px-8 bg-blue-800 hover:bg-blue-600`}
            onClick={() => pushOneArt(art)}
          />
        </Link>
        <MyButton
          title="Delete"
          className={`py-3 px-8 bg-red-800 hover:bg-red-600`}
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
